import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { PlusCircle } from "lucide-react";
import { getNetworkConfig } from "@/lib/api";
import { useWallet } from "@/contexts/WalletContext";
import { Button } from "@/components/ui/button";

const TOKEN_KEYS = [["USDT", "usdt"], ["FBTC", "fbtc"]];

export const AddTokenButtons = () => {
  const { addUSDTToken } = useWallet();
  const { data: config } = useQuery({ queryKey: ["networkConfig"], queryFn: getNetworkConfig });
  const tokens = TOKEN_KEYS.map(([symbol, key]) => ({ symbol, ...config?.[key] })).filter((t) => t.address);
  if (!tokens.length) return null;

  const add = async (t) => {
    const ok = await addUSDTToken(t.address, t.decimals, t.symbol);
    toast[ok ? "success" : "error"](ok ? `${t.symbol} added to your wallet` : `Could not add ${t.symbol} to your wallet`);
  };

  return (
    <div data-testid="faucet-add-tokens" className="pt-2">
      <p className="text-xs text-zinc-500 mb-2">See your tokens in your wallet</p>
      <div className="flex flex-wrap gap-2">
        {tokens.map((t) => (
          <Button key={t.symbol} data-testid={`faucet-add-${t.symbol.toLowerCase()}-btn`} variant="outline" size="sm" onClick={() => add(t)}
            className="border-[#2A2411] bg-[#0A0A0A] text-[#D4AF37] hover:bg-[#D4AF37]/10 hover:text-[#F3E5AB]">
            <PlusCircle size={14} className="mr-1.5" /> Add {t.symbol} to wallet
          </Button>
        ))}
      </div>
    </div>
  );
};
